export default {
  // Regular expression used to validate emails
  EMAIL_REGEX:
    /^[_a-z0-9-]+(.[_a-z0-9-]+)*@[a-z0-9-]+(.[a-z0-9-]+)*(.[a-z]{2,3})$/,
  NIF_REGEX: /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/i,
  PDF_REGEX: /\.pdf$/i,
  URL_REGEX: /^(http|https):\/\/[^ "]+$/,
};
